import { z } from 'zod'

import { blockOf } from './common'
import { BlockType } from './types'

export const CtaButtonVariant = {
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
} as const

export type CtaButtonVariant = (typeof CtaButtonVariant)[keyof typeof CtaButtonVariant]

export const ctaButtonVariantSchema = z.enum(CtaButtonVariant)

export const CtaButtonAlign = {
    LEFT: 'LEFT',
    CENTER: 'CENTER',
    RIGHT: 'RIGHT',
} as const

export type CtaButtonAlign = (typeof CtaButtonAlign)[keyof typeof CtaButtonAlign]

export const ctaButtonAlignSchema = z.enum(CtaButtonAlign)

export const ctaButtonBlockSchema = z.object({
    ...blockOf(BlockType.CTA_BUTTON),
    label: z.string(),
    link: z.string(),
    variant: ctaButtonVariantSchema.default(CtaButtonVariant.PRIMARY),
    align: ctaButtonAlignSchema.default(CtaButtonAlign.CENTER),
})

export type CtaButtonBlockData = z.infer<typeof ctaButtonBlockSchema>
